import { ReactElement, useContext } from 'react'
import { SchedulingWizardContext } from './SchedulingWizard'
import { PATIENT_STATUS_TYPES } from 'lib/scheduling'

export function PatientStatus(): ReactElement {
  const { back, patientType, setPatientType, isPreview } = useContext(SchedulingWizardContext)
  const types = isPreview ? PATIENT_STATUS_TYPES.filter((t) => t !== `Existing Patient`) : PATIENT_STATUS_TYPES
  return (
    <div className={`flex flex-col gap-y-2 ${back ? `animate-fade-right animate-duration-[400ms]` : ``}`}>
      <span className="text-sm font-medium leading-tight text-default">What type of patient are you?</span>
      <div className="flex grow flex-col gap-y-1.5 overflow-y-auto">
        {types.map((type) => (
          <button
            key={type}
            className={`rounded-lg px-4 py-2 text-left text-strong shadow-elevation-1 ${
              patientType === type
                ? `border-2 border-primary-600 bg-primary-alpha-8`
                : `border bg-surface hover:bg-surface-muted`
            }`}
            onClick={() => setPatientType(type)}
          >
            <span className="text-sm font-medium leading-[17.5px]">{type}</span>
          </button>
        ))}
      </div>
    </div>
  )
}
